import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router";

import { getErrorMessage } from "helpers";
import {
  getArticle,
  Article,
  initialArticle,
  putArticle,
  postArticle,
  deleteArticle,
  publishArticle,
} from "services/articles";
import { Image } from "services/images";

export const useArticlePage = (id: number) => {
  const history = useHistory();
  const [formData, setFormData] = useState<Article>(initialArticle);

  // Fetch data
  useEffect(() => {
    (async () => {
      if (id > 0) {
        try {
          const data = await getArticle(id);
          setFormData(data);
        } catch (e) {
          toast.error(getErrorMessage(e));
          console.error(e);
        }
      }
    })();
  }, [id]);

  const inputChanged = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const name = e.target.name;
    const value = e.target.value;

    setFormData((old) => ({ ...old, [name]: value }));
  };

  const onFileChange = (image: Image | null) => {
    setFormData((old) => ({ ...old, image }));
  };

  const onRichTextChange = (value: string, name: string) => {
    setFormData((old) => ({ ...old, [name]: value }));
  };

  const onFormSave = async (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();

    // POST
    if (formData.id < 0) {
      try {
        const newArticle = await postArticle(formData);
        history.push(`/articles/${newArticle.id}`);
        toast.success("Article saved.");
      } catch (e) {
        toast.error(getErrorMessage(e));
        console.error(e);
      }
      return;
    }

    // PUT
    try {
      const newArticle = await putArticle(formData);
      setFormData(newArticle);
      toast.success("Article saved.");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  const onPublishClick = async () => {
    try {
      const newArticle = await publishArticle(formData.id, !formData.published);
      setFormData(newArticle);
      toast.success("Article published.");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  const onDeleteArticle = async () => {
    try {
      await deleteArticle(id);
      toast.success("Article deleted.");
      history.push("/articles");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  return {
    formData,
    onDeleteArticle,
    inputChanged,
    onFileChange,
    onFormSave,
    onRichTextChange,
    onPublishClick,
  };
};
